<rt-form-field>
  <rt-label>
    {{ 'app.interview.due_date' | translate }}
    <rt-icon-help
      [rtTooltip]="'app.interview.due_date_help' | translate"
      rtTooltipPosition="right"
      margin-left-small-xx
    />
    <rt-badge color="pink-gradient" [text]="'app.common.new' | translate" margin-left-small-x />
  </rt-label>

  <div #dueDateOrigin="rtOverlayOrigin" rt-overlay-origin>
    <rt-input
      [readOnly]="true"
      [placeholder]="'app.interview.due_date_placeholder' | translate"
      [hasDropdownIndicator]="!value()"
      [hasClearButton]="!!value()"
      [value]="getTimeDataString() ?? ''"
      [class.dropdownOpened]="dueDateDropdown.open"
      (click)="dueDateDropdown.open = !dueDateDropdown.open"
      (reset)="clear(); $event.stopPropagation()"
      variant="rounded"
      class="no-focus-input"
    >
      <rt-icon prefix name="calendar-today" />
    </rt-input>
  </div>

  <ng-template
    #dueDateDropdown="rtConnectedOverlay"
    rt-connected-overlay
    hasBackdrop
    [origin]="dueDateOrigin"
    (backdropClick)="dueDateDropdown.open = false"
  >
    <rt-dropdown>
      <rt-time-picker
        [value]="value()"
        (valueChange)="onTimeChange($event!); dueDateDropdown.open = false"
      />
    </rt-dropdown>
  </ng-template>
</rt-form-field>
